<script lang="ts">
	import { real_id } from 'src/helpers/interface_helpers';
	import { devices_status, devices_settings } from 'src/stores';
	import type { Device } from 'src/types/Device';
	import ControlOnOffZ from 'src/components/Controls/Single/ControlOnOffZ.svelte';
	import ControlSwitchZ from 'src/components/Controls/Single/ControlSwitchZ.svelte';
	import ControlDirectionDevicePageZ from 'src/components/Controls/Single/ControlDirectionDevicePageZ.svelte';
	import ControlPositionZ from 'src/components/Controls/Single/ControlPositionZ.svelte';
	import ControlBrightnessZ from 'src/components/Controls/Single/ControlBrightnessZ.svelte';
	import InputsReaderVisualizerV2 from 'src/components/Controls/Indicators/InputsReaderVisualizerV2.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import DeviceLabelList from 'src/components/Sidepanel/DeviceViews/DeviceLabelList.svelte';
	import LightAdvancedView from 'src/components/Sidepanel/DeviceViews/Light/LightAdvancedView.svelte';
	import { devices_config } from 'src/configs/devices';
	import { status_configurator } from 'src/helpers/device_data_helpers';
	import { deviceHasZWaveInputs, isZWaveActuatorDevice } from 'src/helpers/z_wave_status_helpers';

	export let device: Device;

	const deviceConfig = devices_config?.[device?.type];

	$: status = $devices_status?.[real_id(device?.id)];
	$: settings = $devices_settings?.[real_id(device?.id)];

	$: _statusesRaw =
		status?.online && deviceConfig ? status_configurator(status, device, settings) : [];
	$: _statuses = Array.isArray(_statusesRaw) ? _statusesRaw : [];
	$: labelList = _statuses.filter((e) => {
		return 'undefined' === typeof e.main && e.name !== 'state';
	});

	$: isCover = device?.category === 'roller' || device?.type === 'ZW-COVER';
	$: isDimmer = device?.category === 'light' || device?.type === 'ZW-DIMMER';
	$: isWaveActuator = isZWaveActuatorDevice(device, status);
	$: isWaveSwitchOnly = isWaveActuator && !isCover && !isDimmer;
	$: isWaveInputsReader =
		device?.type === 'ZW-INPUT' ||
		device?.category === 'inputs_reader' ||
		(deviceHasZWaveInputs(status) && !isWaveActuator);
	$: useLightPriority = isDimmer;
</script>

{#if useLightPriority}
	<LightAdvancedView {device} />
{:else}
	<DeviceViewStateWrapper {device} hideSlotStaticBottom={!isCover && !isDimmer}>
		<div
			slot="staticTop"
			class="label-list-wrapper mb-s d-flex flex-direction-column justify-content-center"
		>
			<DeviceLabelList {labelList} />
			<DeviceNotificationLabel deviceId={device?.id} />
		</div>
		<div
			class="flex-full-height min-height-0 {isWaveInputsReader || isWaveSwitchOnly
				? 'align-items-center justify-content-center'
				: 'justify-content-end'}"
			slot="content"
		>
			{#if status?.online}
				{#if isCover}
					<ControlPositionZ {device} {status} />
				{:else if isDimmer}
					<ControlBrightnessZ {device} {status} />
				{:else if isWaveSwitchOnly}
					<ControlSwitchZ {device} {status} {settings} isWide />
				{:else if isWaveInputsReader}
					<InputsReaderVisualizerV2 {device} {status} {settings} isInCard={false} />
				{/if}
			{/if}
		</div>
		<div class="flex-full-height justify-content-end" slot="staticBottom">
			{#if isCover}
				<ControlDirectionDevicePageZ {device} {status} />
			{:else if isDimmer}
				<ControlOnOffZ
					{device}
					{status}
					{settings}
					isWide
					useV2Components
					deviceButtonV2Props={{ size: 'l' }}
				/>
			{/if}
		</div>
	</DeviceViewStateWrapper>
{/if}
